export const ADJUST_TIMESTAMPS = "ADJUST_TIMESTAMPS";
export const SUBTITLE = "SUBTITLE";

// Modes for adjust timestamp submit form
export const ADJUST_TIMESTAMP_START = "ADJUST_TIMESTAMP_START";
export const ADJUST_TIMESTAMP_END = "ADJUST_TIMESTAMP_END";